import { useQuery } from 'react-query'
import { AxiosError } from 'axios'
import commandBusAPI, { DeviceNotProvisionedError } from '../service/commandBusAPI'
import { DeviceCatalog } from '../types/commandBus.types'

export const useDeviceCatalog = (devEui?: string) => {
  const query = useQuery<DeviceCatalog, AxiosError | DeviceNotProvisionedError>({
    queryKey: ['command-bus', 'catalog', devEui],
    queryFn: () => commandBusAPI.getDeviceCatalog(devEui as string),
    enabled: Boolean(devEui),
    // On rafraichit le catalogue régulièrement pour récupérer le flag
    // momi_online à jour (mis à jour côté backend via WS heartbeat).
    refetchOnWindowFocus: true,
    staleTime: 10_000,
    // Le 404 "device non provisionné" est un état attendu : ne pas retry,
    // sinon on bombarde l'API pour rien.
    retry: (failureCount, error) => {
      if (error instanceof DeviceNotProvisionedError) return false
      return failureCount < 2
    },
  })

  return query
}

export default useDeviceCatalog
